import styled from "@emotion/styled"
import { Container, Typography } from "@mui/material"

const Styled = {
  Wrapper: styled.div`
    padding: 25px 17px;
    background-color: ${(p) => p.theme.colors.paleGrey};
    border: solid 1.5px ${(p) => p.theme.colors.silver};
  `,
  Row: styled.div`
    font-size: 14px;
    line-height: 22px;
    ${(p) => p.theme.breakpoints.up("md")} {
      font-size: 18px;
    }
  `,
  Empty: styled(Typography)`
    font-size: 24px;
    text-align: center;
    color: ${(p) => p.theme.colors.cloudyBlue};
    margin: 0 15px;
    ${(p) => p.theme.breakpoints.down("sm")} {
      span {
        display: block;
      }
    }

    ${(p) => p.theme.breakpoints.up("md")} {
      text-align: left; /* flipped for mui */
      color: ${(p) => p.theme.colors.marine};
      font-weight: bold;
      font-size: 22px;
      margin: 15px 0;
    }
  `,
}

const EmptyResults = () => (
  <Styled.Wrapper>
    <Container>
      <Styled.Row>
        <Styled.Empty>
          <span>לא נמצאו תוצאות</span> <span>מתאימות למה שחיפשת</span>
        </Styled.Empty>
      </Styled.Row>
    </Container>
  </Styled.Wrapper>
)

export default EmptyResults
